import { LoginPage } from 'auth/pages'

export default function Login() {
  return <LoginPage />
}
